import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { PropostaModule } from '../../pages/proposta/proposta.module';
import { CartComponent } from './cart/cart.component';

@NgModule({
	imports: [SharedModule, PropostaModule],
	providers: [],
	declarations: [PersonalDataComponent, CartComponent],
	exports: [PersonalDataComponent]
})
export class OrderModule { }
